module.exports = __webpack_public_path__ + "files/7ea685d1190117e3cfa9ab654230fd22.png";